// MetricsCollector - calculates metrics from event log only
import type { SortEvent, Metrics, SortItem } from './types';

export class MetricsCollectorImpl {
  collect(events: SortEvent[]): Metrics {
    const metrics: Metrics = {
      comparisons: 0,
      swaps: 0,
      overwrites: 0,
      arrayAccesses: 0,
      recursionDepth: 0,
      eventCount: events.length,
      memoryEstimate: 0,
      partitionBalance: 0,
      mergeCount: 0
    };

    let maxDepth = 0;
    let currentDepth = 0;

    for (const event of events) {
      switch (event.type) {
        case 'compare':
          metrics.comparisons++;
          metrics.arrayAccesses += 2;
          break;
        case 'swap':
          metrics.swaps++;
          metrics.arrayAccesses += 4;
          break;
        case 'overwrite':
          metrics.overwrites++;
          metrics.arrayAccesses++;
          break;
        case 'mark':
          metrics.arrayAccesses++;
          break;
        case 'range':
          metrics.arrayAccesses += 3;
          break;
        case 'pivot':
          metrics.arrayAccesses++;
          break;
        case 'split':
          metrics.arrayAccesses += 3;
          maxDepth = Math.max(maxDepth, currentDepth);
          currentDepth++;
          break;
        case 'merge':
          metrics.arrayAccesses += 3;
          metrics.mergeCount = (metrics.mergeCount || 0) + 1;
          currentDepth--;
          break;
        case 'heapify':
          metrics.arrayAccesses += 2;
          break;
        case 'bucket':
          metrics.arrayAccesses++;
          break;
        case 'gap':
          metrics.arrayAccesses++;
          break;
        case 'runDetected':
          metrics.arrayAccesses++;
          break;
        case 'modeSwitch':
          metrics.arrayAccesses++;
          break;
        case 'gallop':
          metrics.arrayAccesses += 3;
          break;
        case 'msdPartition':
          metrics.arrayAccesses += 3;
          maxDepth = Math.max(maxDepth, currentDepth);
          currentDepth++;
          break;
        case 'done':
          currentDepth = 0;
          break;
      }
    }

    metrics.recursionDepth = maxDepth;
    metrics.memoryEstimate = metrics.eventCount * 32;

    return metrics;
  }
}
